import FormControl, { FormControlElement } from './controls/FormControl';
import SelectInput from './controls/SelectInput';
import CheckboxInput from './controls/CheckboxInput';
import RadioInput from './controls/RadioInput';
import TextInput from './controls/TextInput';

export default function createFormHandlerInput($inputs: (FormControlElement)[]) {
  const type = $inputs[0].type.toLowerCase();

  let input: FormControl<FormControlElement>;

  if (type === 'select-one') {
    input = new SelectInput($inputs as HTMLSelectElement[]);
  } else if (type === 'checkbox') {
    input = new CheckboxInput($inputs as HTMLInputElement[]);
  } else if (type === 'radio') {
    input = new RadioInput($inputs as HTMLInputElement[]);
  } else {
    input = new TextInput($inputs as HTMLInputElement[]);
  }

  return input;
}
